import { defineMessages } from 'react-intl';

const trns = defineMessages({
  viewedDrugs: {
    id: 'RTD80P',
    defaultMessage: 'Ви переглядали'
  }
});

export default trns;
